<div class="container-fluid bg-white vh-100 p-0">
  <ClientLogo v-if="this.$route.name != 'behalf_application'" />
  <BreadCrumb label="My Address Information" />

  <div>
    <div v-if="!address_info" class="d-flex justify-content-center align-items-center min-vh-50">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <div class="d-flex align-items-center">
          <span><i class="text-muted bi bi-question-circle me-2"></i></span>
          <span class="text-muted text-xs">The address match process verifies that the provided address aligns with official records,
            ensuring accuracy and compliance.
            </span> 
        </div> 
        <div class="form-group mt-3">
          <label for="id_number" class="form-label fw-bold text-xxs">ID Number <span
              class="text-danger fw-bold">*</span></label>
          <input id="id_number" type="text"
            class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
            :value="id_number"
            placeholder="Enter ID Number"
            maxlength="13"
            @input="allow_num"
            :disabled="is_field_disabled.id_number">
          <div class="d-flex flex-column col-12 col-md-9 col-lg-8 mx-auto mt-1">
            <small class="text-danger fw-bold text-xs d-none id-message">
              Please fill in this field
            </small>
            <small class="text-danger fw-bold text-xs d-none invalid-message">
              Please enter a valid ID number
            </small>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <button
        v-if="!address_info"
        type="button"
        class="btn bg-green btn-sm mt-1 rounded-small shadow-sm fw-bold secondary-text-dark text-xs"
        @click="submit_id"
      >
        Search
      </button>
    </div>

    <div
      class="d-flex justify-content-center align-items-center min-vh-50"
      v-if="address_info"
    >
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-6 p-3">
        <p class="text-xs text-center">
          Please select an address from your address history below or add a new
          address using the form provided.
        </p>
        <hr class="fw-light" />
        <div class="d-flex justify-content-center">
          <ul class="nav nav-tabs mb-2" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active text-dark text-xs"
                id="address-history-tab"
                data-bs-toggle="tab"
                data-bs-target="#address-history"
                type="button"
                role="tab"
                aria-controls="address-history"
                aria-selected="false"
              >
                Address History
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link text-dark text-xs"
                id="add-new-address-tab"
                data-bs-toggle="tab"
                data-bs-target="#add-new-address"
                type="button"
                role="tab"
                aria-controls="add-new-address"
                aria-selected="true"
              >
                Add New Address
              </button>
            </li>
          </ul>
        </div>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade"
            id="add-new-address"
            role="tabpanel"
            aria-labelledby="add-new-address-tab"
          >
            <div>
              <form>
                <div class="mb-3">
                  <label class="text-xs fw-bold">Street Number</label>
                  <input
                    type="text"
                    class="form-control text-xs"
                    v-model="new_address.street_number"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label class="text-xs fw-bold">Address</label>
                  <input
                    type="text"
                    class="form-control text-xs"
                    v-model="new_address.address"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label class="text-xs fw-bold">City</label>
                  <input
                    type="text"
                    class="form-control text-xs"
                    v-model="new_address.city"
                    required
                  />
                </div>
                <div class="mb-3">
                  <label class="text-xs fw-bold">Province</label>
                  <select
                    class="form-control text-xs"
                    v-model="new_address.province"
                    required
                  >
                    <option value="" hidden>Select Province</option>
                    <option value="Eastern Cape">Eastern Cape</option>
                    <option value="Free State">Free State</option>
                    <option value="Gauteng">Gauteng</option>
                    <option value="KwaZulu-Natal">KwaZulu-Natal</option>
                    <option value="Limpopo">Limpopo</option>
                    <option value="Mpumalanga">Mpumalanga</option>
                    <option value="Northern Cape">Northern Cape</option>
                    <option value="North West">North West</option>
                    <option value="Western Cape">Western Cape</option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="text-xs fw-bold">Postal Code</label>
                  <input
                    type="text"
                    class="form-control text-xs"
                    v-model="new_address.postal_code"
                    required
                  />
                </div>
              </form>
              <div class="text-center">
                <button type="button" class="btn btn-bg-green rounded-small text-xs" @click="add_address">
                  Add Address
                </button>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show active"
            id="address-history"
            role="tabpanel"
            aria-labelledby="address-history-tab"
          >
            <div class="row" v-if="address_info.length > 0">
              <div
                class="col-sm-6 p-1"
                v-for="(address, index) in address_info"
              >
                <div class="card shadow rounded-3 h-100">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-12">
                        <label class="">
                          <i class="fas fa-map-marker-alt"></i>
                          <span class="fw-bold text-xs px-2 pb-3">Address</span>
                        </label>
                        <p class="text-s">{{ address.Address }}</p>
                      </div>
                      <div class="col-sm-12 row">
                        <div class="col-sm-6">
                          <label class="">
                            <i class="fas fa-calendar-alt"></i>
                            <span class="fw-bold text-xs px-2 pb-3"
                              >Last Updated</span
                            >
                          </label>
                          <p class="text-xs">{{ address.LastUpdatedDate }}</p>
                        </div>
                        <div class="col-sm-6">
                          <label class="">
                            <i class="fas fa-calendar-alt"></i>
                            <span class="fw-bold text-xs px-2 pb-3"
                              >First Reported</span
                            >
                          </label>
                          <p class="text-xs">{{ address.FirstReportedDate }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer d-flex justify-content-center bg-white border-0 rounded-3"
                  >
                    <button
                      type="button"
                      class="btn btn-bg-green rounded-small text-xs"
                      @click="select_address(address)"
                    >
                      Select
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="card shadow rounded-3 border-light">
                <div class="card-body text-center">
                  <p
                    class="d-flex justify-content-center align-items-center flex-column"
                  >
                    <i
                      class="fas fa-exclamation-triangle text-warning text-md p-2"
                    ></i>
                    <span class="text-xs text-muted p-2">
                      No address history found.
                    </span>
                    <span class="text-xs text-muted">
                      Please add a new address using the form provided below.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
